/* eslint-disable import/prefer-default-export */
import useAxios from '../hooks/useAxios';
import { dialogActions } from '../reducers/dialogReducer';

// eslint-disable-next-line consistent-return
export const handleUpdateTransTime = async (newCancelToken, dialogDispatch, data) => {
  const cancelToken = newCancelToken();
  const [status, result, noPrivilegeMsg] = await useAxios(
    '/updateTransTime',
    { timerRecord: data },
    true,
    cancelToken
  );
  if (status) {
    const { timerRecord } = result;
    return [status, timerRecord];
  }
  dialogDispatch({
    type: dialogActions.OPEN,
    config: {
      singleBtn: true,
      title: '更新錯誤',
      message: result || noPrivilegeMsg || '目前無法更新PROCESS時間，請稍後再試，或聯繫網管人員',
    },
  });
  return [status];
};
/**
 * Get transfer information.
 * @param {Object} data - The data object containing the following properties:
 * @param {CancelToken} cancelToken - The cancel token.
 * @param {function} onSuccess - The function to call when the request is successful.
 * @param {function} onError - The function to call when the request is failed.
 * @param {function} [params.onSettled] - The function to call when the request is finished.
 * @returns {Promise<any>} The API response.
 */
export const handleForceUpdateTransTime = async (params) => {
  const { data, cancelToken, onSuccess, onError, onSettled } = params;
  const [status, result, rtCode, noPrivilegeMsg] = await useAxios(
    '/updateTransTime/force',
    { timerRecord: data },
    true,
    cancelToken
  );
  onSettled?.();
  if (status) {
    onSuccess?.(result);
  } else {
    onError?.(result, rtCode, noPrivilegeMsg);
  }
};
